import { logError } from "src/errorHandling/errorLogging.ts";
import { DeliveryPackageSource } from "src/api/generated/erp/delivery/model/deliveryPackageSource.ts";
import { Address } from "src/api/generated/erp/db/types/embeddables/address.ts";
import {
	DeliveryPackageWithSourcesView
} from "src/api/generated/erp/db/types/tables/deliveryPackageWithSourcesView.ts";
import {
	DeliveryPackageSourceType
} from "src/api/generated/io/aavo/applications/db/erp/types/deliveryPackageSourceType.ts";

export function createDeliveryPackageSource({
	sourceType,
	sourceId,
}: {
	sourceType: DeliveryPackageSourceType;
	sourceId: number | null | undefined;
}): DeliveryPackageSource | undefined {
	switch (sourceType) {
		case "CUSTOMER_ORDER":
			if (sourceId == null) {
				logError("Source ID is null for delivery source type CUSTOMER_ORDER");
			}
			return {
				type: "customerOrder",
				customerOrderId: sourceId!,
			};
		case "PROJECT":
			if (sourceId == null) {
				logError("Source ID is null for delivery source type PROJECT");
			}
			return {
				type: "project",
				projectId: sourceId!,
			};
	}
}

export function createNullableDeliveryPackageSource({
	sourceType,
	sourceId,
}: {
	sourceType: DeliveryPackageSourceType | null | undefined;
	sourceId: number | null | undefined;
}): DeliveryPackageSource | undefined {
	if (sourceType != null && sourceId != null) {
		return createDeliveryPackageSource({ sourceType, sourceId });
	}
	return undefined;
}

export function deliveryPackageSourceToKey(source: DeliveryPackageSource | undefined): string {
	if (source == null) return "NONE";
	switch (source.type) {
		case "customerOrder":
			return `CUSTOMER_ORDER_${source.customerOrderId}`;
		case "project":
			return `PROJECT_${source.projectId}`;
	}
}

export function getDeliveryPackageAddress(deliveryPackage: DeliveryPackageWithSourcesView): Address | undefined {
	if (
		deliveryPackage.sourceDeliveryAddress_1 == null ||
		deliveryPackage.sourceDeliveryAddress_2 == null ||
		deliveryPackage.sourceDeliveryPostalCode == null ||
		deliveryPackage.sourceDeliveryCity == null ||
		deliveryPackage.sourceDeliveryCountry == null
	)
		return undefined;

	return {
		address_1: deliveryPackage.sourceDeliveryAddress_1,
		address_2: deliveryPackage.sourceDeliveryAddress_2,
		postalCode: deliveryPackage.sourceDeliveryPostalCode,
		city: deliveryPackage.sourceDeliveryCity,
		country: deliveryPackage.sourceDeliveryCountry,
	};
}

export function getDeliveryPackageSources(deliveryPackage: DeliveryPackageWithSourcesView): DeliveryPackageSource[] {
	const customerOrders: DeliveryPackageSource[] = deliveryPackage.sourceCustomerOrderIds.map((customerOrderId) => ({
		type: "customerOrder",
		customerOrderId: customerOrderId,
	}));

	const projects: DeliveryPackageSource[] = deliveryPackage.sourceProjectIds.map((projectId) => ({
		type: "project",
		projectId: projectId,
	}));

	return [...customerOrders, ...projects];
}
